import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES,
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE,
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE,
	},
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE,
	},
}
